import { render, staticRenderFns } from "./unreadNotifications.vue?vue&type=template&id=32a41e46"
import script from "./unreadNotifications.vue?vue&type=script&lang=js"
export * from "./unreadNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports